import { keepPreviousData, useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { reportingUrl } from "report/Constants";
import { defaultOnError } from "util/conditional/onError";
const fetchReportSummary = (reportId) => fetch("GET", reportingUrl(`${reportId}/summary`));
const useReportSummary = (reportId, refetchPeriodically = false) => {
  const { data, isInitialLoading } = useQuery({
    queryKey: ["reports", "summary", reportId],
    queryFn: () => defaultOnError(fetchReportSummary(reportId), "Fetching report failed with status", "Could not retrieve report"),
    placeholderData: keepPreviousData,
    refetchInterval: refetchPeriodically ? 2e3 : void 0
  });
  return {
    data,
    isInitialLoading
  };
};
export default useReportSummary;
